/**
 * Extrae todas las URLs internas (que empiezan con /) del menú del usuario.
 * Recorre ítems y children de forma recursiva.
 * @param {Array} menu - Array de ítems del menú (cada ítem puede tener url y children)
 * @returns {Set<string>} Set de rutas permitidas (ej: '/gestion-usuarios', '/perfil-cliente')
 */
export const getMenuPaths = (menu) => {
  const paths = new Set();
  if (!menu || !Array.isArray(menu)) return paths;

  const collect = (items) => {
    if (!items || !Array.isArray(items)) return;
    items.forEach((item) => {
      if (item.url && typeof item.url === 'string') {
        const u = item.url.trim();
        // Solo rutas internas: empiezan por / o no son enlaces externos (http)
        if (u.startsWith('/') || !u.startsWith('http')) {
          const path = u.startsWith('/') ? u : `/${u}`;
          paths.add(path.replace(/\/+$/, ''));
        }
      }
      if (item.children && item.children.length > 0) {
        collect(item.children);
      }
    });
  };

  collect(menu);
  return paths;
};

/**
 * Indica si la ruta actual está permitida según el menú.
 * - Coincidencia exacta: pathname está en el menú.
 * - Rutas dinámicas: pathname es de la forma /recurso/:id y en el menú está /recurso.
 * @param {string} pathname - Ej: '/perfil-cliente/5'
 * @param {Set<string>} allowedPaths - Rutas permitidas por el menú
 * @param {boolean} allowHome - Si true, '/' siempre se considera permitido
 * @returns {boolean}
 */
export const isPathAllowedByMenu = (pathname, allowedPaths, allowHome = true) => {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (allowHome && normalized === '/') return true;
  if (allowedPaths.has(normalized)) return true;
  // Rutas con parámetro: /perfil-cliente/123 permitida si en menú está /perfil-cliente
  for (const path of allowedPaths) {
    if (path !== '/' && normalized.startsWith(path + '/')) return true;
  }
  return false;
};
